import { useEffect } from 'react';
import { useTheCatchContext } from '@/context/TheCatchContext'
import ContentSections from '@/components/Sections/ContentSections'
import PageSEO from '@/components/SEO/PageSEO'
import { getRecentArticlesHandles } from '@/utils/getRecentArticleHandles'
import { getCatchDataByHandles } from '@/utils/getCatch'
import { getSanityClient } from '@/services/sanityClient';
import groq from 'groq';
import { PreviewButton } from '@/components/Preview/PreviewButton';

const TheCatch = ({ page, preview, previewToken }) => {
  const theCatchContext = useTheCatchContext()
  const { addIssue, addFilteredIssue, monthName } = theCatchContext

  useEffect(() => {
    const filtered = page.fields?.content?.filter(content => content._type === 'staticHarvest')
    const found = filtered.find(staticHarvest => staticHarvest.harvestMonth[0].month.toLowerCase() === monthName)

    addIssue(page)
    addFilteredIssue(found)
  }, [])

  return (
    <div className='main--the-catch'>
      {preview && previewToken && <PreviewButton />}
      <PageSEO seo={page.fields.seo} />
      <ContentSections sections={page.fields.content} />
    </div>
  )
}

export default TheCatch

export async function getStaticPaths() {
  const catches = await getSanityClient().fetch(
    groq`*[_type == "theCatch"]{ handle { current } }`
  )
  const handles = catches
    .filter((page) => (page.handle.current))
    .map((page) => ({ params: { handle: page.handle.current } }))

  return {
    paths: handles,
    fallback: 'blocking'
  }
}

export async function getStaticProps({ params, draftMode }) {
  const preview = draftMode || false;
  const previewToken = preview ? process.env.SANITY_READ_TOKEN : ``;
  if (preview && !previewToken) {
    throw new Error(`Preview mode is active, but SANITY_READ_TOKEN is not set in environment variables`);
  }

  const sanityClient = getSanityClient(previewToken)

  const page = (await getCatchDataByHandles([params.handle], sanityClient))[0]

  if (!page) {
    return {
      notFound: true
    }
  }

  if (page?.fields?.content?.some(content => content._type === 'featuredBlogContent')) {
    await getRecentArticlesHandles(page.fields.content)
  }

  return {
    props: {
      page,
      handle: params.handle,
      preview,
      previewToken
    }
  }
}
